import { RoutesPaths } from "src/routes/RoutesPaths";

export const routePath = {
  lk: RoutesPaths.LK.API_KNOWLEDGE_BASE,
  base: "/knowledge-base",
} as const;

export type RoutePathKeys = keyof typeof routePath;

export const ARTICLE_ROUTE = ":sectionSlug/:docSlug";
